import { Input, InputProps, buildChangeEventLike } from 'components/Blocks';
import { NumericFormat, OnValueChange } from 'react-number-format';

export type DecimalInputProps = {
  children?: never;

  value?: string;
  defaultValue?: string;

  onChangeDirect?: (value: string) => void;
} & Omit<InputProps, 'type' | 'value' | 'defaultValue'>;

export function DecimalInput({ onChange, onChangeDirect, ...props }: DecimalInputProps) {
  // This verification is being done because when an id is not passed in the input,
  // the lib creates one like this: :r1n:
  const id = props.id?.startsWith(':') ? undefined : props.id;

  const handleChange: OnValueChange = (values) => {
    onChange?.(
      buildChangeEventLike({
        id,
        name: props.name,
        value: values.value,
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
      }) as any,
    );

    onChangeDirect?.(values.value);
  };

  return (
    <NumericFormat
      {...props}
      // getInputRef={ref}
      customInput={Input}
      focusStyle="border"
      onValueChange={handleChange}
      valueIsNumericString
      allowNegative={false}
      decimalSeparator="."
      decimalScale={2}
      fixedDecimalScale
      thousandSeparator
    />
  );
}
